import { Component, OnDestroy, signal, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LiveTradingBannersService } from '../services/live-trading-banners.service';
import { Banner } from '../models/banner';

@Component({
  selector: 'app-live-trading-banners',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './live-trading-banners.component.html',
  styleUrls: ['./live-trading-banners.component.scss']
})
export class LiveTradingBannersComponent implements OnDestroy {
  private liveTradingBannersService = inject(LiveTradingBannersService);

  private currentBannerIndex = signal(0);
  isTransitioning = signal(false);

  activeBanners = this.liveTradingBannersService.getBanners();
  currentBanner = computed(() => {
    const banners = this.activeBanners();
    const index = this.currentBannerIndex();
    return banners.length > 0 ? banners[index] : null;
  });

  private imageTimer?: ReturnType<typeof setTimeout>;

  ngOnDestroy(): void {
    this.clearTimers();
  }

  isVideoFormat(fileUrl: string): boolean {
    const extension = fileUrl.split('.').pop()?.toLowerCase();
    return extension === 'mp4' || extension === 'webm';
  }

  onVideoEnded(): void {
    this.nextBanner();
  }

  onVideoLoad(event: Event): void {
    const video = event.target as HTMLVideoElement;
    video.muted = true;
    video.play().catch(err => {
      console.error('Failed to autoplay video:', err);
      setTimeout(() => this.nextBanner(), 1000);
    });
  }

  onImageLoad(): void {
    this.clearTimers();
    this.imageTimer = setTimeout(() => {
      this.nextBanner();
    }, 15000);
  }

  onError(): void {
    this.clearTimers();
    setTimeout(() => this.nextBanner(), 1000);
  }

  private nextBanner(): void {
    const banners = this.activeBanners();
    if (banners.length === 0) return;

    this.clearTimers();
    this.isTransitioning.set(true);

    setTimeout(() => {
      const currentIndex = this.currentBannerIndex();
      const nextIndex = (currentIndex + 1) % banners.length;
      this.currentBannerIndex.set(nextIndex);

      setTimeout(() => {
        this.isTransitioning.set(false);
      }, 300);
    }, 300);
  }

  private clearTimers(): void {
    if (this.imageTimer) {
      clearTimeout(this.imageTimer);
      this.imageTimer = undefined;
    }
  }
}